export const BANNER_HEIGHT = 128;
export const AUTO_ROTATE_MS = 7000;
export const PAUSE_AFTER_INTERACTION_MS = 12000;
export const SLIDE_DURATION_MS = 400;
